import Image from 'next/image'
import { classNames } from '@/util/tailwindHelpers'

interface CharacterGroupProps {
  side: 'L' | 'R'
  className?: string
  amount: 3
}

const CharacterGroup = ({ side, amount, className }: CharacterGroupProps) => {
  const translateXSymbol = side === 'L' ? '-' : ''
  return (
    <div
      className={classNames('absolute top-0 left-1/2 w-[35vw] h-0', className)}
      style={{
        transform: `translateX(calc(-50% + var(--groupXSpread) * ${translateXSymbol}1)) translateY(0px) translateZ(var(--groupZ)) scale(1)`,
        transformStyle: 'preserve-3d'
      }}
    >
      {Array.from({ length: amount }).map((_, i) => {
        const id = `${side}${i + 1}`

        return (
          <div
            key={id}
            className="w-[35vw] h-[35vw] absolute bottom-0"
            style={{
              transform: `translateX(calc(var(--characterXOffset) * ${translateXSymbol}${i} )) translateZ(calc(var(--characterZSpread) * ${i}))`
            }}
          >
            <Image
              alt="arcade control"
              src={`/images/arcade/${id}.svg`}
              layout="fill"
              objectFit="contain"
            />
          </div>
        )
      })}
    </div>
  )
}

export default CharacterGroup
